<template>
  <div class="container-notificacao" style="padding-bottom: 6rem;">
    <header>
      <h1>NOVA NOTIFICAÇÃO</h1>
    </header>
    <section class="suporte">
      <div class="contaner">
        <div class="row">

          <div class="row">
            <div class="col">
              <div class="form-outline">
                <input type="text" class="form-control" id="" v-model="titulo">
                <label class="form-label" for="">Titulo:</label>
                <FormNotch />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="form-outline">
                <textarea type="text" class="form-control" :rows="textareaRows" placeholder="" 
                  v-model="descricao"></textarea>
                <label class="form-label" for="">Descrição:</label>
                <FormNotch />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <div class="form-outline ">
                <input type="text" class="form-control" id="" ref="urlServico" v-model="itemOperadoras">
                <label class="form-label" for="">Operadoras:</label>
                <FormNotch />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col d-flex justify-content-center">
              <button @click="salvar()" type="submit" class="btn btn-primary mt-1">ENVIAR</button>
            </div>
          </div>

        </div>
      </div>
    </section>
    <div class="loader">
      <div>
        <div class="spinner-border"></div>
      </div>
    </div>
  </div>
</template>

<script>
import FormNotch from './FormNotch.vue';
import * as alertUtils from '@/utils/alert';
import * as loaderUtils from '@/utils/loader';
import axios from "axios";

export default {
  components: {
    FormNotch
  },

  data() {
    return {
      titulo: "",
      descricao: "",
      itemOperadoras: "",
      operadoras: [],
      textareaRows: 2
    };
  },

  methods: {
    async salvar() {

      this.popularOperadoras();

      const requestBody = {
        titulo: this.titulo,
        descricao: this.descricao,
        operadoras: this.operadoras
      };

      loaderUtils.addLoarder();
      try {
        const operadorasUrl = '/massificados/corporativo/gerenciador-parceiros/notificacao-api/incluir';
        const requestOptions = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(requestBody)
        };

        const response = await fetch(operadorasUrl, requestOptions);
        console.log(response);
        alertUtils.alertSuccess("Notificação criada com sucesso!");

      } catch (error) {
        alertUtils.alertError('Erro ao criar notificação: ' + error.message);

      } finally {
        loaderUtils.removeLoader();
        this.titulo = "";
        this.descricao = "";
        this.itemOperadoras = "";
        this.operadoras = "";
        this.resetForm();
      }

    },
    popularOperadoras() {
      if (this.itemOperadoras) {
        this.operadoras = this.itemOperadoras
          .split(',')
          .map(op => op.trim())
          .filter(op => op !== '');
      } else {
        this.operadoras = [];
      }
    },
    updateRowsByScreenWidth() {
      const width = window.innerWidth;

      if (width >= 1920) {
        this.textareaRows = 7;
      } else {
        this.textareaRows = 2;
      }
    },
  },

  created() {
    // console.log('criado');
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.updateRowsByScreenWidth);
  },

  mounted() {
    this.updateRowsByScreenWidth();
    window.addEventListener('resize', this.updateRowsByScreenWidth);
  },
}
</script>
<style scoped>
@import '/massificados/corporativo/gerenciador-parceiros-ui/nova-notificacao/css/style.css';
</style>